type PageLink = {
	uuid: string;
	href: string;
	label: string;
};

export const pageLinks: PageLink[] = [
	{
		uuid: "a196b98c-9345-4957-9166-1441de01f5ed",
		href: "/",
		label: "Home",
	},
	{
		uuid: "a196b98c-9355-40ad-8d34-4c2db1f8112c",
		href: "/offerings",
		label: "Offerings",
	},
	{
		uuid: "a196b98c-9359-47b9-9fde-ae3027fb1f1d",
		href: "/about",
		label: "About Us",
	},
	{
		uuid: "a196b98c-935d-4653-8185-7890c7c75e43",
		href: "/contact",
		label: "Contact Us",
	},
];
